module.exports = __webpack_public_path__ + "92dd1a9494f07f9ed1b96babad1b5201.png";